import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export async function listMediaOutlets() {
  const { data } = await client.get('/media/outlets');
  return data.outlets || [];
}

export async function listMediaArticles({ outletSlug, limit = 60, since } = {}) {
  const params = {};
  if (outletSlug) params.outlet_slug = outletSlug;
  if (limit) params.limit = limit;
  if (since) params.since = since;
  const { data } = await client.get('/media/articles', { params });
  return data.articles || [];
}

const mediaService = { listMediaOutlets, listMediaArticles };
export default mediaService;
